import { Button } from "@/components/ui/buttons/Button";

type Props = {
    isToggled: boolean;
    label: string;
    toggle: () => void;
};

const Toggle = (props: Props) => {
    const { isToggled, label, toggle } = props;

    return (
        <Button variant={isToggled ? "primary" : "outline"} onClick={toggle}>
            {label}
        </Button>
    );
};

export { Toggle };
export type { Props as ToggleProps };
